import { render, staticRenderFns } from "./modifyApplyLabel.vue?vue&type=template&id=060355e7&"
import script from "./modifyApplyLabel.vue?vue&type=script&lang=js&"
export * from "./modifyApplyLabel.vue?vue&type=script&lang=js&"
import style0 from "./modifyApplyLabel.vue?vue&type=style&index=0&lang=less&scope=true&"
import style1 from "./modifyApplyLabel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports